export default __webpack_public_path__ + "static/media/ff-home.880e40fc.png";